exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-c8a70580] {\r\n  width: 1.25em;\r\n  height: 1.25em;\r\n  vertical-align: -0.2em;\r\n  fill: currentColor;\r\n  stroke: currentColor;\r\n  overflow: hidden;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c8a70580","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SvgIcon/index.vue
// module id = dde6
// module chunks = 477